import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3141, { U3141ROLES } from "./U3141";
import U3141LandRegisterList from "./components/U3141LandRegisterList";
import U3141MasterLotChainForm from "./components/U3141MasterLotChainForm";
import U3141ChildLotChainForm from "./components/U3141ChildLotChainForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3141Routes: RouteObject[] = [
  {
    path: "U3141",
    element: <U2000RequireRole allowedRoles={[U3141ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3141 />,
        children: [
          { index: true, element: <U3141LandRegisterList /> },
          {
            path: ":id/childLotChain/:childLotChainId",
            element: <U3141ChildLotChainForm />,
          },
          { path: ":id", element: <U3141MasterLotChainForm /> },
        ],
      },
    ],
  },
];

export default U3141Routes;
